// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1Wpai","table":"styles_table__2FTp0"};